import { render, staticRenderFns } from "./LoadingCard.vue?vue&type=template&id=1b80ff3e&scoped=true"
import script from "./LoadingCard.vue?vue&type=script&lang=js"
export * from "./LoadingCard.vue?vue&type=script&lang=js"
import style0 from "./LoadingCard.vue?vue&type=style&index=0&id=1b80ff3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b80ff3e",
  null
  
)

export default component.exports